import { useCallback, useEffect, useRef, useState } from "react";
import { useWebHaptics } from "web-haptics/react";

export function useCopyFeedback<T>(resetAfterMs = 2000) {
  const [copiedValue, setCopiedValue] = useState<T | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const haptic = useWebHaptics();

  const copy = useCallback(
    async (text: string, value: T) => {
      await navigator.clipboard.writeText(text);
      haptic.trigger("success");
      setCopiedValue(value);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setCopiedValue(null);
        timeoutRef.current = null;
      }, resetAfterMs);
    },
    [resetAfterMs, haptic]
  );

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { copiedValue, copy };
}
